import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import React from "react";
import { Helmet } from "react-helmet";
import Cookies from "js-cookie";
import "./support.css";
import { Toast } from "../components_root/ToastContext.jsx";
import { MdLocationCity } from "react-icons/md";
import { Telegram_bot } from "../bot_toot/telegram_bot.js";
export const seo = {
  title: "Aooz Status Support | Help Center",
  description:
    "Need help using Aooz Status? Find answers to FAQs, report issues, and contact our support team for assistance with status sharing and platform features.",
  keywords:
    "aooz status support, aooz status help, status website support, contact aooz status, aooz help center",
  url: "https://status.aooz.in/support",
  image: "https://status.aooz.in/logo.png",
};

export default function Support() {
  const { Toastshow } = Toast();
  const navigate = useNavigate();


  const [guid, setGuid] = useState(Cookies.get("guid") || "no-guid");
  

const [messages, setMessages] = useState("");

  const post_telegram_bot = async (messages = "default") => {
    if (!messages) {
      Toastshow("Please enter a message to post.", "warning");
      return;
    }
 

    const res = await Telegram_bot({
      message: `${messages} - from Aooz Status Support (${new Date().toLocaleString()}, ${"Guid:"+guid})  `,
      chat_id: "312215558" // ✅ FIXED
    });

    console.log(res);

    if (res?.success) {
      setMessages("");
      Toastshow("Your message has been sent to our support team. We will get back to you shortly.", "success"); 
    }
    else{
      Toastshow("Failed to send your message. Please try again later.", "error");
    }
    
  };
  return (
    <div>

      <Helmet>
        <title>{seo.title}</title>
        <meta name="description" content={seo.description} />
        <meta name="keywords" content={seo.keywords} />
        <meta property="og:title" content={seo.title} />
        <meta property="og:description" content={seo.description} />
        <meta property="og:image" content={seo.image} />
        <meta property="og:url" content={seo.url} />
      </Helmet>

      <div className="container_roots">
        <div className='container_size_info'>

          <h2 className="bold text-hero-sub">Support Center – Aooz Status</h2>

          <div className="post-container text-pre-30">

            {/* LEFT */}
            <div className="post-div">

              <div className="text-hero-sub">How can we help you?</div>

              <div className="trxt-h2">

                Welcome to <b>Aooz Status Support</b>.
                Our platform provides a collection of status messages, quotes,
                and social media captions that users can easily copy and share.

                <br /><br />

                If you experience any issue while browsing, copying,
                or sharing status content, our support team is here to help.

              </div>


              <div className="text-hero-sub mt-3">Common Support Topics</div>

              <div className="trxt-h2">

                ✅ Status copy or share not working <br />
                ✅ Website loading problems <br />
                ✅ Incorrect or broken status content <br />
                ✅ Report inappropriate content <br />
                ✅ Feature suggestions <br />
                ✅ Technical issues or bugs

              </div>


              <div className="text-hero-sub mt-3">Quick Tips</div>

              <div className="trxt-h2">

                💡 Refresh the page if content does not load. <br />
                💡 Use the latest browser for best experience. <br />
                💡 Check your internet connection. <br />
                💡 Report any incorrect status so we can improve our platform.

              </div>

            </div>


            {/* RIGHT */}
            <div className="post-updates">
            
              <div className="text-hero-sub">Contact Support</div>

              <div className="trxt-h2">

                📩 <b>Email:</b> aoozsupport@gmail.com <br />
                🌐 <b>Website:</b> status.aooz.in <br />
                🕐 <b>Support Hours:</b> 10 AM – 7 PM (Mon–Sat)

              </div>

        <textarea rows={5} placeholder="Enter your message" onChange={(e) => setMessages(e.target.value)} value={messages} maxLength={200} />
               
              <table>
                
                <tr>
                    <td width={30}>{messages.length}/200</td>
                  <td align="right">
                  
                    <button className="button-ui p-22 cursor" onClick={() => post_telegram_bot(messages)}>
                      Inquiry
                    </button>
                  </td>
                </tr>
              </table>
              <div className="text-hero-sub mt-3">Office</div>

              <div className="trxt-h2">

                <MdLocationCity size={20} style={{ marginRight: "6px" }} />
                India
                <br />

                <span style={{ opacity: 0.8 }}>
                  (Online platform support)
                </span>

              </div>


              <div className="text-hero-sub mt-3">Need Faster Help?</div>

              <div className="trxt-h2">

                Please include:

                <br />

                ✅ Screenshot of the issue <br />
                ✅ Page URL where problem happened <br />
                ✅ Short description of the problem <br />
                ✅ Device & browser name

              </div>

            </div>

          </div>


          {/* FAQ SECTION */}
          <div className="post-div mt-3">

            <div className="text-hero-sub">FAQs</div>

            <div className="trxt-h2">

              <b>Q1. Can I copy status messages for free?</b>
              <br />
              Yes, all status messages on Aooz Status can be copied and shared for personal use.

              <br /><br />

              <b>Q2. Do I need an account to use the website?</b>
              <br />
              No, the website can be used freely without registration.

              <br /><br />

              <b>Q3. Can I share these statuses on WhatsApp or Instagram?</b>
              <br />
              Yes, you can copy and share the statuses on any social media platform.

              <br /><br />

              <b>Q4. How can I report incorrect content?</b>
              <br />
              Please contact us by email and share the page link.

              <br /><br />

              <b>Q5. Can I suggest new status categories?</b>
              <br />
              Yes! We welcome suggestions to improve the platform.

            </div>

          </div>


          {/* CTA */}
          <div className="post-div mt-3">
            <br />
            <div className="text-hero-sub">Still Need Help?</div>

            <div className="trxt-h2">

              If you didn't find your answer, feel free to contact us anytime.

              <br /><br />

              <b>Aooz Status Support Team</b> is always ready to help.

            </div>

          </div>

        </div>
      </div>
      <br /><br />
    </div>
  );
}